import { Role } from '@cpd-app/core-module/models';

export enum UserRole {
  SuperAdmin = 'SUPERADMIN',
  CouncelorAdmin = 'COUNCELORADMIN',
  Councelor = 'COUNCELOR',
  Anonymous = 'ANONYMOUS'
}

export const ROLES: Role[] = [
  {
    value: UserRole.Councelor,
    name: 'Counselor',
    description:
      'Can view analytics dashboard, but cannot invite members or change settings'
  },
  {
    value: UserRole.CouncelorAdmin,
    name: 'Counselor Admin',
    description:
      'Can view analytics dashboard, invite members and change member settings'
  },
  {
    value: UserRole.SuperAdmin,
    name: 'Super Admin',
    description: ''
  },
  {
    value: UserRole.Anonymous,
    name: 'Anonymous',
    description: ''
  }
];
